import { render, staticRenderFns } from "./mentionable.vue?vue&type=template&id=ed01397c&"
import script from "./mentionable.vue?vue&type=script&lang=js&"
export * from "./mentionable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports